import { FC, PropsWithChildren, useRef, useState } from 'react'
import { useHeaderHeightObserver } from 'components/_hooks/useHeaderHeightObserver'
import { useDimensions } from 'components/_hooks/useDimensions'

export interface OnRailsWrapperProps extends PropsWithChildren {
	height: string
	topOffset?: number
	centered?: boolean
	debug?: boolean
}

export const OnRailsWrapper: FC<OnRailsWrapperProps> = (props) => {
	const [debugColor] = useState(Math.floor(Math.random() * 16777215).toString(16))
	const ref = useRef<HTMLDivElement | null>(null)
	const { height } = useDimensions(ref)

	// TODO, can we change this to return the observer instead of the value? That way we can use it however we want
	const headerHeight = useHeaderHeightObserver()
	let top = `${headerHeight + (props.topOffset || 0)}px`

	if (props.centered) {
		top = `calc(50vh - ${height / 2}px + ${props.topOffset || 0}px)`
	}

	return (
		<div
			style={{
				height: props.height,
				outline: props.debug ? `#${debugColor} dashed` : '',
			}}
		>
			<div
				ref={ref}
				style={{ position: 'sticky', top: top }}
			>
				{props.children}
			</div>
		</div>
	)
}
